export default {
  buildCreate(reason) {
    return {
      'data': {
        'attributes': {
          'reason': reason,
        },
        'type': 'reason-for-resolving',
      },
    };
  },
  buildUpdate(reason, id) {
    return {
      'data': {
        'attributes': {
          'reason': reason,
        },
        'id': id,
        'type': 'reason-for-resolving',
      },
    };
  },
  async getExistingReasons(axios, reasonStore, token) {
    let response = await axios.get('/api/message/reasons-for-resolving/', {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    response.data.data.forEach(reason => {
      reasonStore.replaceOrAdd(reason);
    });
  },
  async createReason(data, axios, token) {
    return await axios.post('/api/message/reasons-for-resolving/', data, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
  async deleteReason(reasonId, axios, token) {
    return await axios.delete(`/api/message/reasons-for-resolving/${reasonId}/`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
  async updateReason(reasonId, data, axios, token) {
    return await axios.patch(`/api/message/reasons-for-resolving/${reasonId}/`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  }
};
